import { DocTypeEnum } from "@common/constants/enums/docType";

export const getNameFromDNI = (type, value, verificationOptions = {}) => {
  if (type !== DocTypeEnum.DNI) return ''.padStart(value.length, '*');

  const firstUnmasked = value.substring(0, 2);
  const secondUnmasked = value.substring(7);

  const masked = ''.padStart(value.length - firstUnmasked.length - secondUnmasked.length, '*');

  return `${firstUnmasked}${masked}${secondUnmasked.length && verificationOptions.enableDNIFormatting ? '-' + secondUnmasked : secondUnmasked}`;
};

export const getNameFromPlatformPlayer = (firstName, lastName) => {
  if (!firstName || !lastName) return '';

  const maskedFirstName = firstName.charAt(0) + '*'.repeat(firstName.length - 1);
  const maskedLastName = lastName.charAt(0) + '*'.repeat(lastName.length - 1);

  return `${maskedFirstName} ${maskedLastName}`;
};
